import type { OrganisationUsers } from '../reducers/customer'
import type { ApiKey, CustomerActionTypes, NewApiKey, OrganisationUser, OrganisationVehicle, Subtree, ToolCategory, ToolConfiguration } from '../types/customer'
import { EXPIRED_API_KEY_BY_FORCE, FETCHED_API_KEYS, FETCHED_ORGANISATION_NAME, FETCH_API_KEYS, FETCH_ORGANISATION_NAME, FETCH_SUBTREES, FORCE_EXPIRE_API_KEY, RECEIVED_NEW_API_KEY, REQUEST_API_KEY, SUBTREES_FETCHED, SET_SELECTED_ORGANISATIONS, APP_STARTED, AUTHENTICATED_USER_FETCHED, ADD_CHILD_NODE, CHILD_NODE_ADDED, CHILD_NODE_REMOVED, REMOVE_CHILD_NODE, ADD_USER_TO_CHILD_NODE, USER_TO_CHILD_NODE_ADDED, ORGANISATION_NODE_SELECTED, FETCH_ORGANISATION_NODE_USERS, GET_USERS_FROM_NODE, UPDATE_USER_PRIVILEGE, UPDATED_PRIVILEGE_TO_USER, VEHICLE_TO_CHILD_NODE_ADDED, REMOVE_USER_FROM_CHILD_NODE, USER_FROM_CHILD_NODE_REMOVED, MODIFY_VEHICLE_TO_CHILD_NODE, VEHICLE_TO_CHILD_NODE_REMOVED, MOVE_USER_TO_CHILD_NODE, USER_FROM_CHILD_NODE_MOVED, EDIT_CHILD_NODE, CHILD_NODE_EDITED, MOVE_USER_TO_CHILD_NODE_FAILED, GET_ALL_USERS_FROM_ORGANISATION, FETCHED_USERS_FROM_ORGANISATION, GET_ALL_VEHICLES_FROM_ORGANISATION, FETCHED_VEHICLES_FROM_ORGANISATION, FETCH_ORGANISATION_TOOL_CONFIG, FETCHED_ORGANISATION_TOOL_CONFIG } from '../types/customer'

export const fetchSubtrees = (accessToken: string) : CustomerActionTypes => ({
  type: FETCH_SUBTREES,
  accessToken
})

export const fetchOrganisationName = (accessToken: string, id: string) : CustomerActionTypes => ({
  type: FETCH_ORGANISATION_NAME,
  accessToken,
  id
})

export const fetchApiKeys = (accessToken: string, includeExpired: boolean) : CustomerActionTypes => ({
  type: FETCH_API_KEYS,
  accessToken,
  includeExpired
})

export const requestApiKey = (accessToken: string, expiresAt: Date, organisations: string[]) : CustomerActionTypes => ({
  type: REQUEST_API_KEY,
  accessToken,
  expiresAt,
  organisations
})

export const forceExpireApiKey = (accessToken: string, id: string) : CustomerActionTypes => ({
  type: FORCE_EXPIRE_API_KEY,
  accessToken,
  id
})

export const subtreesFetched = (subtrees: Subtree[]) : CustomerActionTypes => ({
  type: SUBTREES_FETCHED,
  subtrees,
  total: subtrees.length
})

export const fetchedOrganisationName = (data: any) : CustomerActionTypes => ({
  type: FETCHED_ORGANISATION_NAME,
  organisation: {
    translated: data.translated,
    uuid: data.organisationId
  }
})

export const fetchedApiKeys = (keys: ApiKey[], total: number) : CustomerActionTypes => ({
  type: FETCHED_API_KEYS,
  keys,
  total
})

export const receivedNewApiKey = (key: NewApiKey) : CustomerActionTypes => ({
  type: RECEIVED_NEW_API_KEY,
  key
})

export const expiredApiKeyByForce = (id: string) : CustomerActionTypes => ({
  type: EXPIRED_API_KEY_BY_FORCE,
  id
})

export const setSelectedOrganisations = (uuids: string[]) : CustomerActionTypes => ({
  type: SET_SELECTED_ORGANISATIONS,
  uuids
}) 

export const appStarted = (token: string, email: string) : CustomerActionTypes => ({
  type: APP_STARTED,
  token,
  email
})

export const authenticatedUserFetched = (token: string, user: object, isNewUser: boolean) : CustomerActionTypes => ({
  type: AUTHENTICATED_USER_FETCHED,
  token,
  user,
  isNewUser
})

export const addChildNode = (token: string, parentId: string, name: string) : CustomerActionTypes => ({
  type: ADD_CHILD_NODE,
  token,
  parentId,
  name
  
})
export const childNodeAdded = (uuid: string, name: string, parentId: string,) : CustomerActionTypes => ({
  type: CHILD_NODE_ADDED,
  uuid,
  name,
  parentId,
  
})

export const removeChildNode = (token: string, id: string) : CustomerActionTypes => ({
  type: REMOVE_CHILD_NODE,
  token,
  id
})

export const childNodeRemoved = (id: string) : CustomerActionTypes => ({
  type: CHILD_NODE_REMOVED,
  id
})

export const editChildNode = (token: string, id: string, newName: string) : CustomerActionTypes => ({
  type: EDIT_CHILD_NODE,
  token,
  id,
  newName
})
export const childNodeEdited = (id: string, newName: string) : CustomerActionTypes => ({
  type: CHILD_NODE_EDITED,
  id,
  newName
})

export const addUserToChildNode = (token: string, id: string, firstName: string, lastName: string, email: string, privilege: string) : CustomerActionTypes => ({
  type: ADD_USER_TO_CHILD_NODE,
  token,
  id,
  firstName,
  lastName,
  email,
  privilege
})

export const removeUserFromOrganisation = (token: string, email: string, organisation: string, name: string
) : CustomerActionTypes => ({
  type: REMOVE_USER_FROM_CHILD_NODE,
  token,
  email,
  organisation,
  name
})

export const childNodeUserRemoved = (email: string, organisation: string
) : CustomerActionTypes => ({
  type: USER_FROM_CHILD_NODE_REMOVED,
  email,
  organisation
})


export const userHasBeenAdded = (id: string, firstName: string, lastName: string, email: string, privilege: string) : CustomerActionTypes => ({
  type: USER_TO_CHILD_NODE_ADDED,
  id,
  firstName,
  lastName,
  email,
  privilege
  
})
export const organisationNodeSelected = (id: string) : CustomerActionTypes => ({
  type: ORGANISATION_NODE_SELECTED,
  id
  
})

export const getUsersFromNode = (token: string, uuid: string) : CustomerActionTypes => ({
  type: GET_USERS_FROM_NODE,
  token,
  uuid
  
})
export const fetchedOrganisationNodeUsers = (id: string, users: OrganisationUsers[]) : CustomerActionTypes => ({
  type: FETCH_ORGANISATION_NODE_USERS,
  id,
  users
})

export const updateUserPrivilege = (token: string, email: string, tags: string, id: string, privilege: string) : CustomerActionTypes => ({
  type: UPDATE_USER_PRIVILEGE,
  token,
  email,
  tags,
  id,
  privilege
})

export const updatedPrivilegeToUser = (id: string, privilege: string, email: string) : CustomerActionTypes => ({
  type: UPDATED_PRIVILEGE_TO_USER,
  id,
  email,
  privilege
})

export const modifyVehicleToOrganisation = (token: string, id: string, vehicleName: string,
  model: string, year: string, licenseNumber: string, organisation: string, shouldRemove: boolean
) : CustomerActionTypes => ({
  type: MODIFY_VEHICLE_TO_CHILD_NODE,
  token,
  id,
  vehicleName,
  model, 
  year,
  licenseNumber,
  organisation,
  shouldRemove
})

export const vehicleTochildNodeAdded = (id: string, vehicleName: string,
  model: string, year: string, licenseNumber: string, organisation: string) : CustomerActionTypes => ({
  type: VEHICLE_TO_CHILD_NODE_ADDED,
  id,
  vehicleName,
  model, 
  year,
  licenseNumber,
  organisation
})

export const VehicleTochildNodeRemoved = (id: string, organisation: string) : CustomerActionTypes => ({
  type: VEHICLE_TO_CHILD_NODE_REMOVED,
  id,
  organisation
})

export const moveUserToChildNode = (token: string, email: string, uuid: string, privilege: string, name: string, parentUuid: string) : CustomerActionTypes => ({
  type: MOVE_USER_TO_CHILD_NODE,
  token,
  email,
  uuid,
  privilege,
  name,
  parentUuid
})

export const userHasBeenMoved = (name: string, email: string, uuid: string, privilege: string) : CustomerActionTypes => ({
  type: USER_FROM_CHILD_NODE_MOVED,
  name,
  email,
  uuid,
  privilege
})

export const getAllUsersFromOrganisation = (token: string, orgId: string) : CustomerActionTypes => ({
  type: GET_ALL_USERS_FROM_ORGANISATION,
  token,
  orgId
})

export const fetchedUsersFromOrganisation = (orgId: string, users: OrganisationUser[], total: number) : CustomerActionTypes => ({
  type: FETCHED_USERS_FROM_ORGANISATION,
  orgId,
  users,
  total
})

export const getAllVehiclesFromOrganisation = (token: string, orgId: string) : CustomerActionTypes => ({
  type: GET_ALL_VEHICLES_FROM_ORGANISATION,
  token,
  orgId
})

export const fetchedVehiclesFromOrganisation = (orgId: string, vehicles: OrganisationVehicle[], total: number) : CustomerActionTypes => ({
  type: FETCHED_VEHICLES_FROM_ORGANISATION,
  orgId,
  vehicles,
  total
})

export const fetchOrganisationToolConfig = (token: string, orgId: string) : CustomerActionTypes => ({
  type: FETCH_ORGANISATION_TOOL_CONFIG,
  token,
  orgId
})

export const fetchedOrganisationToolConfig = (orgId: string, toolConfig: ToolConfiguration) : CustomerActionTypes => ({
  type: FETCHED_ORGANISATION_TOOL_CONFIG,
  orgId,
  toolConfig
})

export const addToolCategories = (token: string, orgId: string, categories: ToolCategory[]) => ({
  type: 'ADD_TOOL_CATEGORIES',
  token,
  orgId,
  categories
})

export const addToolCategory = (token: string, orgId: string, category: string, iconUrl: string) => ({
  type: 'ADD_TOOL_CATEGORY',
  token,
  orgId,
  category,
  iconUrl
})

export const addToolBrand = (token: string, orgId: string, brand: string) => ({
  type: 'ADD_TOOL_BRAND',
  token,
  orgId,
  brand
})

export const addToolEquipmentName = (token: string, orgId: string, equipmentName: string) => ({
  type: 'ADD_TOOL_EQUIPMENT_NAME',
  token,
  orgId,
  equipmentName
})

export const removeToolCategory = (token: string, orgId: string, category: string, iconUrl: string) => ({
  type: 'REMOVE_TOOL_CATEGORY',
  token,
  orgId,
  category,
  iconUrl
})

export const removeToolBrand = (token: string, orgId: string, brand: string) => ({
  type: 'REMOVE_TOOL_BRAND',
  token,
  orgId,
  brand
})

export const removeToolEquipmentName = (token: string, orgId: string, equipmentName: string) => ({
  type: 'REMOVE_TOOL_EQUIPMENT_NAME',
  token,
  orgId,
  equipmentName
})

export const editToolCategory = (token: string, orgId: string, oldCategory: string, newCategory: string, oldIconUrl: string, newIconUrl: string) => ({
  type: 'EDIT_TOOL_CATEGORY',
  token,
  orgId,
  oldCategory,
  newCategory,
  oldIconUrl,
  newIconUrl
})

export const editToolBrand = (token: string, orgId: string, oldBrand: string, newBrand: string) => ({
  type: 'EDIT_TOOL_BRAND',
  token,
  orgId,
  oldBrand,
  newBrand
})

export const editToolEquipmentName = (token: string, orgId: string, oldEquipmentName: string, newEquipmentName: string) => ({
  type: 'EDIT_TOOL_EQUIPMENT_NAME',
  token,
  orgId,
  oldEquipmentName,
  newEquipmentName
})

export const toggleCustomCategories = (token: string, orgId: string, isEnabled: boolean) => ({
  type: 'TOGGLE_CUSTOM_CATEGORIES',
  token,
  orgId,
  isEnabled
})

export const toggleCustomBrands = (token: string, orgId: string, isEnabled: boolean) => ({
  type: 'TOGGLE_CUSTOM_BRANDS',
  token,
  orgId,
  isEnabled
})

export const toggleCustomEquipmentNames = (token: string, orgId: string, isEnabled: boolean) => ({
  type: 'TOGGLE_CUSTOM_EQUIPMENT_NAMES',
  token,
  orgId,
  isEnabled
})